import Swiper from 'swiper/bundle';

document.addEventListener("DOMContentLoaded", function () {
    const peopleSlider = document.querySelector('.more-people__slider');

    if (peopleSlider) {
        const swiper = new Swiper(peopleSlider, {
            slidesPerView: "auto",
            freeMode: true,
			// Enable scrollbar
			scrollbar: {
				el: '.swiper-scrollbar', // Element selector for the scrollbar
				draggable: true,         // Allows dragging the scrollbar to control the slider position
				dragSize: '250px',         // Width of the draggable scrollbar
			},
        });
    }
});